// src/redux/actions/timesheetActions.js

// =========================
// TYPES
// =========================
export const SET_TIMESHEET_LOADING = "SET_TIMESHEET_LOADING";
export const CLEAR_TIMESHEET_ERROR = "CLEAR_TIMESHEET_ERROR";

export const FETCH_TIMESHEETS_REQUEST = "FETCH_TIMESHEETS_REQUEST";
export const FETCH_TIMESHEETS_SUCCESS = "FETCH_TIMESHEETS_SUCCESS";
export const FETCH_TIMESHEETS_FAIL = "FETCH_TIMESHEETS_FAIL";

export const GET_TIMESHEET_REQUEST = "GET_TIMESHEET_REQUEST";
export const GET_TIMESHEET_SUCCESS = "GET_TIMESHEET_SUCCESS";
export const GET_TIMESHEET_FAIL = "GET_TIMESHEET_FAIL";

export const CREATE_TIMESHEET_REQUEST = "CREATE_TIMESHEET_REQUEST";
export const CREATE_TIMESHEET_SUCCESS = "CREATE_TIMESHEET_SUCCESS";
export const CREATE_TIMESHEET_FAIL = "CREATE_TIMESHEET_FAIL";

export const UPDATE_TIMESHEET_REQUEST = "UPDATE_TIMESHEET_REQUEST";
export const UPDATE_TIMESHEET_SUCCESS = "UPDATE_TIMESHEET_SUCCESS";
export const UPDATE_TIMESHEET_FAIL = "UPDATE_TIMESHEET_FAIL";

export const DELETE_TIMESHEET_REQUEST = "DELETE_TIMESHEET_REQUEST";
export const DELETE_TIMESHEET_SUCCESS = "DELETE_TIMESHEET_SUCCESS";
export const DELETE_TIMESHEET_FAIL = "DELETE_TIMESHEET_FAIL";

export const FETCH_TIMESHEET_DAYS_REQUEST = "FETCH_TIMESHEET_DAYS_REQUEST";
export const FETCH_TIMESHEET_DAYS_SUCCESS = "FETCH_TIMESHEET_DAYS_SUCCESS";
export const FETCH_TIMESHEET_DAYS_FAIL = "FETCH_TIMESHEET_DAYS_FAIL";

export const UPSERT_TIMESHEET_DAY_REQUEST = "UPSERT_TIMESHEET_DAY_REQUEST";
export const UPSERT_TIMESHEET_DAY_SUCCESS = "UPSERT_TIMESHEET_DAY_SUCCESS";
export const UPSERT_TIMESHEET_DAY_FAIL = "UPSERT_TIMESHEET_DAY_FAIL";

export const DELETE_TIMESHEET_DAY_REQUEST = "DELETE_TIMESHEET_DAY_REQUEST";
export const DELETE_TIMESHEET_DAY_SUCCESS = "DELETE_TIMESHEET_DAY_SUCCESS";
export const DELETE_TIMESHEET_DAY_FAIL = "DELETE_TIMESHEET_DAY_FAIL";

// =========================
// HELPERS
// =========================
export const setTimesheetLoading = (loading) => ({
    type: SET_TIMESHEET_LOADING,
    payload: loading,
});

export const clearTimesheetError = () => ({
    type: CLEAR_TIMESHEET_ERROR,
});

// =========================
// TIMESHEETS (HEADER)
// =========================
export const fetchTimesheetsRequest = () => ({ type: FETCH_TIMESHEETS_REQUEST });
export const fetchTimesheetsSuccess = (data) => ({ type: FETCH_TIMESHEETS_SUCCESS, payload: data });
export const fetchTimesheetsFail = (error) => ({ type: FETCH_TIMESHEETS_FAIL, payload: error });

export const getTimesheetRequest = (id) => ({ type: GET_TIMESHEET_REQUEST, payload: id });
export const getTimesheetSuccess = (data) => ({ type: GET_TIMESHEET_SUCCESS, payload: data });
export const getTimesheetFail = (error) => ({ type: GET_TIMESHEET_FAIL, payload: error });

export const createTimesheetRequest = (payload) => ({ type: CREATE_TIMESHEET_REQUEST, payload });
export const createTimesheetSuccess = (data) => ({ type: CREATE_TIMESHEET_SUCCESS, payload: data });
export const createTimesheetFail = (error) => ({ type: CREATE_TIMESHEET_FAIL, payload: error });

export const updateTimesheetRequest = (id, payload) => ({
    type: UPDATE_TIMESHEET_REQUEST,
    payload: { id, payload },
});
export const updateTimesheetSuccess = (data) => ({ type: UPDATE_TIMESHEET_SUCCESS, payload: data });
export const updateTimesheetFail = (error) => ({ type: UPDATE_TIMESHEET_FAIL, payload: error });

export const deleteTimesheetRequest = (id) => ({ type: DELETE_TIMESHEET_REQUEST, payload: id });
export const deleteTimesheetSuccess = (id) => ({ type: DELETE_TIMESHEET_SUCCESS, payload: id });
export const deleteTimesheetFail = (error) => ({ type: DELETE_TIMESHEET_FAIL, payload: error });

// =========================
// DAYS (LINES)
// =========================
export const fetchTimesheetDaysRequest = (timesheetId) => ({
    type: FETCH_TIMESHEET_DAYS_REQUEST,
    payload: timesheetId,
});
export const fetchTimesheetDaysSuccess = (timesheetId, days) => ({
    type: FETCH_TIMESHEET_DAYS_SUCCESS,
    payload: { timesheetId, days },
});
export const fetchTimesheetDaysFail = (error) => ({ type: FETCH_TIMESHEET_DAYS_FAIL, payload: error });

export const upsertTimesheetDayRequest = (payload) => ({
    type: UPSERT_TIMESHEET_DAY_REQUEST,
    payload, // {timesheetId, workDate, heures, commentaire?}
});
export const upsertTimesheetDaySuccess = (data) => ({
    type: UPSERT_TIMESHEET_DAY_SUCCESS,
    payload: data, // TimesheetDayResponseDTO
});
export const upsertTimesheetDayFail = (error) => ({ type: UPSERT_TIMESHEET_DAY_FAIL, payload: error });

export const deleteTimesheetDayRequest = (dayId, timesheetId) => ({
    type: DELETE_TIMESHEET_DAY_REQUEST,
    payload: { dayId, timesheetId },
});
export const deleteTimesheetDaySuccess = (dayId, timesheetId) => ({
    type: DELETE_TIMESHEET_DAY_SUCCESS,
    payload: { dayId, timesheetId },
});
export const deleteTimesheetDayFail = (error) => ({ type: DELETE_TIMESHEET_DAY_FAIL, payload: error });
